import {
  showError,
  showSuccess,
  extractErrorMessage,
} from "../errorservices/errorservices";
import type { ApiResponse } from "./ApiResponse";
import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";
import { getToken } from "@/app/services/context/tokenGetter";
import { executeLogout } from "@/app/utils/loginFlow/logoutHelper";
import { store, type RootState } from "@/app/redux/store";
import { userNotificationEndPoints } from "../urlConfig/apiEndpoints";
import {
  CORRELATION_ID_HEADER,
  generateCorrelationId,
} from "@/app/utils/loginFlow/correlationId";

const getTenantId = (): string | undefined => {
  const state = store.getState() as RootState;
  return state.userData?.data?.tenantId;
};

// ---------------- Auth logout registration ----------------
const handleUnauthorized = (err: any) => {
  executeLogout();
  return Promise.reject(err);
};

const handleApiRequest = async <T>(
  method: typeof axios.get | typeof axios.post | typeof axios.delete,
  url: string,
  payload: any = {},
  showSuccessMsg?: boolean,
): Promise<ApiResponse<T>> => {
  try {
    const token = getToken();
    const tenantId = getTenantId();
    const correlationId = generateCorrelationId();
    const headers: Record<string, string | undefined> = {
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
      appId: tenantId,
      [CORRELATION_ID_HEADER]: correlationId,
    };
    if (!(payload instanceof FormData))
      headers["Content-Type"] = "application/json";

    const config: AxiosRequestConfig = { headers };
    const response: AxiosResponse =
      method === axios.get || method === axios.delete
        ? await method(url, { ...config, params: payload })
        : await method(url, payload, config);

    const data: ApiResponse<T> = response.data;

    if (data?.status === 0) {
      if (showSuccessMsg && data.errorMessage) showSuccess(data.errorMessage);
      return data;
    }

    if (data?.status === 1) {
      if (showSuccessMsg && data.errorMessage) showSuccess(data.errorMessage);
      return data;
    }

    if (data?.status === 2) {
      showError(undefined, data.errorMessage || "Request failed.");
      throw new Error(data.errorMessage || "Request failed.");
    }

    throw new Error("Unexpected server response.");
  } catch (err: any) {
    const { code, message } = extractErrorMessage(err);

    if (code === 401) {
      return handleUnauthorized(err);
    }

    showError(code, message);
    return Promise.reject(err);
  }
};

// ----------------  API  gxnotifyViewApi ----------------
export const gxnotifyViewApi = (payload: any) => {
  return handleApiRequest(
    axios.post,
    userNotificationEndPoints.gxnotify,
    payload,
  );
};

// ----------------  API  gxnotifycategoryAPi ----------------
export const gxnotifycategoryAPi = () => {
  return handleApiRequest(
    axios.post,
    userNotificationEndPoints.gxnotifycategory,
  );
};

// ----------------  API  gxnotifyupdateApi ----------------
export const gxnotifyupdateApi = (payload: any) => {
  return handleApiRequest(
    axios.post,
    userNotificationEndPoints.gxnotifyupdate,
    payload,
  );
};
